
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  folderSwitchViewMine: {
    id: "FolderSwitchView.mine",
    defaultMessage: "My Configurations",
  },
  goBack: {
    id: "FolderSwitchView.goBack",
    defaultMessage: "Go back",
  }
});

export default MESSAGES;